import MyLocations from './myLocations'
export default MyLocations
